import React, { useState, useContext } from 'react';
import {
  makeStyles,
  Grid,
  TextField,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from '@material-ui/core';
import InputMask from 'react-input-mask';
import _ from 'lodash';

import zipApi from 'app/api/services/zipCodeEndpoints';
import { Field } from 'formik';
import generalEndpoints from 'app/api/services/generalEndpoints';
import { useSelector, useDispatch } from 'react-redux';
import { setCity } from 'app/store/slices/forms';
import { FormServiceContext } from 'app/utils/contexts';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { SERVICES_CODES } from 'app/config/services';

import styles from './styles';
const useStyles = makeStyles(styles);

function Address(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { errors, values, isHeadquarters } = props;

  const { canEdit } = useContext(FormServiceContext);
  const cepMask = '99999-999';

  const [loadingHeadquartersAddress, setLoadingHeadquartersAddress] = useState(false);
  const [loadingiBranchAddress, setLoadingiBranchAddress] = useState(false);
  const [cities, setCities] = useState([]);
  const [citiesBranch, setCitiesBranch] = useState([]);

  const city = useSelector(state => state.forms.city);
  const service = useSelector(state => state.services.details);

  const searchAddress = async (e, tipo) => {
    let cep = e.target.value;
    if (tipo === 'matriz') setLoadingHeadquartersAddress(true);
    if (tipo === 'filial') setLoadingiBranchAddress(true);

    if (cep && cep !== '') {
      cep = cep.replace(/[^0-9]+/g, '');
      if (cep.length === 8) {
        const result = await zipApi.zipCodeSearch(cep);
        if (result) {
          if (result.erro) {
            result.cep = cep;
            result.uf = '';
            result.localidade = '';
            result.bairro = '';
            result.logradouro = '';
            await dispatch(setCity({}));
          }
          if (tipo === 'filial') {
            if (!values.enderecoFilial) values.enderecoFilial = {};
            values.enderecoFilial.deCep = result.cep;
            values.enderecoFilial.uf = result.uf;
            values.enderecoFilial.municipio = result.localidade;
            values.enderecoFilial.deBairro = result.bairro;
            values.enderecoFilial.deEndereco = result.logradouro;
            if (!result.erro) {
              const response = await searchCity(result.uf, 'filial.uf');
              const cityFound = _.find(response, ['nmMunicipio', result.localidade]);
              if (cityFound) {
                await onChangeBranchCity(null, cityFound);
              }
            }
          } else if (tipo === 'matriz') {
            if (!values.enderecoMatriz) values.enderecoMatriz = {};
            values.enderecoMatriz.deCep = result.cep;
            values.enderecoMatriz.uf = result.uf;
            values.enderecoMatriz.municipio = result.localidade;
            values.enderecoMatriz.deBairro = result.bairro;
            values.enderecoMatriz.deEndereco = result.logradouro;
            if (!result.erro) {
              const response = await searchCity(result.uf, 'matriz.uf');
              const cityFound = _.find(response, ['nmMunicipio', result.localidade]);
              if (cityFound) {
                await onChangeCity(null, cityFound);
              }
            }
          }
        }
      }
    }
    setLoadingHeadquartersAddress(false);
    setLoadingiBranchAddress(false);
  };

  const searchCity = async (uf, tipo) => {
    if (tipo === 'matriz.uf') setLoadingHeadquartersAddress(true);
    if (tipo === 'filial.uf') setLoadingiBranchAddress(true);
    if (uf && uf !== '') {
      const response = await generalEndpoints.getCities(uf);
      if (tipo === 'matriz.uf') {
        if (setCities) setCities(response.data);
      } else {
        if (setCitiesBranch) setCitiesBranch(response.data);
      }
      setLoadingHeadquartersAddress(false);
      setLoadingiBranchAddress(false);
      return response.data;
    }
    setLoadingHeadquartersAddress(false);
    setLoadingiBranchAddress(false);
  };

  const onChangeCity = (e, v) => {
    const value = v ? v : e.target.value;
    if (value) {
      const temp = { ...city };
      temp.cityPrincipal = { ...value };
      if (!temp.cityPrincipal.nmMunicipio) temp.cityPrincipal.nmMunicipio = value;
      dispatch(setCity(temp));
      values.enderecoMatriz.municipio = value;
      values.enderecoMatriz.cdMunicipio = value.cdMunicipio;
    } else {
      const temp = _.cloneDeep(city);
      if (temp.cityPrincipal) delete temp.cityPrincipal;
      dispatch(setCity(temp));
      values.enderecoMatriz.municipio = {};
      values.enderecoMatriz.cdMunicipio = null;
    }
  };

  const onChangeBranchCity = (e, v) => {
    const value = v ? v : e.target.value;
    if (value) {
      const temp = { ...city };
      temp.citySecondary = { ...value };
      if (!temp.citySecondary.nmMunicipio) temp.citySecondary.nmMunicipio = value;
      dispatch(setCity(temp));
      values.enderecoFilial.municipio = value;
      values.enderecoFilial.cdMunicipio = value.cdMunicipio;
    } else {
      const temp = _.cloneDeep(city);
      if (temp.citySecondary) delete temp.citySecondary;
      dispatch(setCity(temp));
      values.enderecoFilial.municipio = {};
      values.enderecoFilial.cdMunicipio = null;
    }
  };

  return (
    <>
      <Grid container spacing={3} className={classes.containerAddessTitle}>
        <Grid item xs={12}>
          <h3 className={classes.addressTitle}>Endereço Matriz</h3>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={2} className={classes.positionRelative}>
          {canEdit && service.cdServico !== SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC ? (
            <Field name="enderecoMatriz.deCep">
              {({ field, form: { errors, values } }) => (
                <InputMask
                  mask={cepMask}
                  {...field}
                  value={values.enderecoMatriz?.deCep ? values.enderecoMatriz.deCep : ''}
                  onBlur={e => searchAddress(e, 'matriz')}
                >
                  {props => (
                    <TextField
                      {...props}
                      name="enderecoMatriz.deCep"
                      label="CEP*"
                      variant="filled"
                      margin="dense"
                      fullWidth
                      error={!!errors.enderecoMatriz?.deCep}
                      helperText={errors.enderecoMatriz?.deCep ? errors.enderecoMatriz.deCep : ''}
                      inputProps={{
                        form: {
                          autocomplete: 'off',
                        },
                      }}
                    />
                  )}
                </InputMask>
              )}
            </Field>
          ) : (
            <TextField
              value={values.enderecoMatriz?.deCep ? values.enderecoMatriz.deCep : ''}
              label="CEP*"
              variant="filled"
              margin="dense"
              disabled
              fullWidth
            />
          )}
          {loadingHeadquartersAddress && (
            <CircularProgress
              className={classes.circularProgress}
              disableShrink={true}
              size={18}
              thickness={6}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            error={!!errors.enderecoMatriz?.uf}
          >
            <InputLabel
              htmlFor="uf"
              shrink={values.enderecoMatriz?.uf || city?.cityPrincipal?.uf?.sgUf ? true : false}
            >
              UF*
            </InputLabel>
            <Field
              name="enderecoMatriz.uf"
              id="matriz.uf"
              native
              as={Select}
              value={
                values.enderecoMatriz?.uf
                  ? values.enderecoMatriz?.uf
                  : city?.cityPrincipal?.uf?.sgUf
                  ? city.cityPrincipal.uf.sgUf
                  : ''
              }
              onBlur={e => searchCity(e.target.value, 'matriz.uf')}
            >
              <option value=""></option>
              <option value="AC">AC</option>
              <option value="AL">AL</option>
              <option value="AM">AM</option>
              <option value="AP">AP</option>
              <option value="BA">BA</option>
              <option value="CE">CE</option>
              <option value="DF">DF</option>
              <option value="ES">ES</option>
              <option value="GO">GO</option>
              <option value="MA">MA</option>
              <option value="MG">MG</option>
              <option value="MS">MS</option>
              <option value="MT">MT</option>
              <option value="PA">PA</option>
              <option value="PB">PB</option>
              <option value="PE">PE</option>
              <option value="PI">PI</option>
              <option value="PR">PR</option>
              <option value="RJ">RJ</option>
              <option value="RN">RN</option>
              <option value="RO">RO</option>
              <option value="RR">RR</option>
              <option value="RS">RS</option>
              <option value="SC">SC</option>
              <option value="SE">SE</option>
              <option value="SP">SP</option>
              <option value="TO">TO</option>
            </Field>
            {errors.enderecoMatriz?.uf ? (
              <FormHelperText>{errors.enderecoMatriz?.uf}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field name="enderecoMatriz.municipio">
            {({ field, form: { errors } }) => {
              return (
                <div className={classes.positionRelative}>
                  <Autocomplete
                    options={cities}
                    getOptionLabel={option => (option['nmMunicipio'] ? option['nmMunicipio'] : '')}
                    value={city?.cityPrincipal ? city?.cityPrincipal : {}}
                    onChange={onChangeCity}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Município*"
                        fullWidth
                        variant="filled"
                        margin="dense"
                        disabled={
                          !canEdit ||
                          service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
                        }
                        error={!!errors.enderecoMatriz?.municipio}
                        helperText={
                          errors.enderecoMatriz?.municipio?.cdMunicipio
                            ? errors.enderecoMatriz.municipio.cdMunicipio
                            : ''
                        }
                      />
                    )}
                  />
                  {loadingHeadquartersAddress && (
                    <CircularProgress
                      className={classes.circularProgress}
                      disableShrink={true}
                      size={18}
                      thickness={6}
                    />
                  )}
                </div>
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            name="enderecoMatriz.deBairro"
            label="Bairro*"
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            error={!!errors.enderecoMatriz?.deBairro}
            helperText={errors.enderecoMatriz?.deBairro ? errors.enderecoMatriz.deBairro : ''}
            value={values.enderecoMatriz?.deBairro ? values.enderecoMatriz.deBairro : ''}
            as={TextField}
            inputProps={{
              maxLength: 50,
              form: {
                autocomplete: 'off',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name="enderecoMatriz.deEndereco"
            label="Endereço*"
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            error={!!errors.enderecoMatriz?.deEndereco}
            helperText={errors.enderecoMatriz?.deEndereco ? errors.enderecoMatriz.deEndereco : ''}
            value={values.enderecoMatriz?.deEndereco ? values.enderecoMatriz.deEndereco : ''}
            as={TextField}
            inputProps={{
              maxLength: 100,
              form: {
                autocomplete: 'off',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Field
            name="enderecoMatriz.deNumeroEndereco"
            label="Número"
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            error={!!errors.enderecoMatriz?.deNumeroEndereco}
            helperText={
              errors.enderecoMatriz?.deNumeroEndereco ? errors.enderecoMatriz.deNumeroEndereco : ''
            }
            value={
              values.enderecoMatriz?.deNumeroEndereco ? values.enderecoMatriz.deNumeroEndereco : ''
            }
            as={TextField}
            inputProps={{
              maxLength: 7,
              form: {
                autocomplete: 'off',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            name="enderecoMatriz.deComplemento"
            label="Complemento"
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            value={values.enderecoMatriz?.deComplemento ? values.enderecoMatriz.deComplemento : ''}
            as={TextField}
            inputProps={{
              maxLength: 50,
              form: {
                autocomplete: 'off',
              },
            }}
          />
        </Grid>
      </Grid>
      {!isHeadquarters && (
        <>
          <Grid container spacing={3} className={classes.containerAddessTitle}>
            <Grid item xs={12}>
              <h3 className={classes.addressTitle}>Endereço Filial</h3>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={2} className={classes.positionRelative}>
              {canEdit && service.cdServico !== SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC ? (
                <Field name="enderecoFilial.deCep">
                  {({ field, form: { errors, values } }) => (
                    <InputMask
                      mask={cepMask}
                      {...field}
                      value={values.enderecoFilial?.deCep ? values.enderecoFilial.deCep : ''}
                      onBlur={e => searchAddress(e, 'filial')}
                    >
                      {props => (
                        <TextField
                          {...props}
                          name="enderecoFilial.deCep"
                          label="CEP*"
                          variant="filled"
                          margin="dense"
                          fullWidth
                          error={!!errors.enderecoFilial?.deCep}
                          helperText={
                            errors.enderecoFilial?.deCep ? errors.enderecoFilial.deCep : ''
                          }
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                        />
                      )}
                    </InputMask>
                  )}
                </Field>
              ) : (
                <TextField
                  value={values.enderecoFilial?.deCep ? values.enderecoFilial.deCep : ''}
                  label="CEP*"
                  variant="filled"
                  margin="dense"
                  disabled
                  fullWidth
                />
              )}
              {loadingiBranchAddress && (
                <CircularProgress
                  className={classes.circularProgress}
                  disableShrink={true}
                  size={18}
                  thickness={6}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormControl
                variant="filled"
                margin="dense"
                disabled={
                  !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
                }
                fullWidth
                error={!!errors.enderecoFilial?.uf}
                helperText={errors.enderecoFilial?.uf ? errors.enderecoFilial.uf : ''}
              >
                <InputLabel
                  htmlFor="uf"
                  shrink={values.enderecoFilial?.uf || city?.citySecondary?.uf?.sgUf ? true : false}
                >
                  UF*
                </InputLabel>
                <Field
                  name="enderecoFilial.uf"
                  id="filial.uf"
                  native
                  displayEmpty
                  isClearable
                  as={Select}
                  onBlur={e => searchCity(e.target.value, 'filial.uf')}
                  value={
                    values.enderecoFilial?.uf
                      ? values.enderecoFilial?.uf
                      : city?.citySecondary?.uf?.sgUf
                      ? city.citySecondary.uf.sgUf
                      : ''
                  }
                >
                  <option value=""></option>
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AM">AM</option>
                  <option value="AP">AP</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MG">MG</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="PA">PA</option>
                  <option value="PB">PB</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="PR">PR</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="RS">RS</option>
                  <option value="SC">SC</option>
                  <option value="SE">SE</option>
                  <option value="SP">SP</option>
                  <option value="TO">TO</option>
                </Field>
                {errors.enderecoFilial?.uf ? (
                  <FormHelperText>{errors.enderecoFilial.uf}</FormHelperText>
                ) : null}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Field name="enderecoFilial.municipio">
                {({ field, form: { errors } }) => {
                  return (
                    <div className={classes.positionRelative}>
                      <Autocomplete
                        options={citiesBranch}
                        getOptionLabel={option =>
                          option['nmMunicipio'] ? option['nmMunicipio'] : ''
                        }
                        value={city?.citySecondary ? city?.citySecondary : {}}
                        onChange={onChangeBranchCity}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label="Município*"
                            fullWidth
                            variant="filled"
                            margin="dense"
                            disabled={
                              !canEdit ||
                              service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
                            }
                            error={!!errors.enderecoFilial?.municipio}
                            helperText={
                              errors.enderecoFilial?.municipio?.cdMunicipio
                                ? errors.enderecoFilial.municipio.cdMunicipio
                                : ''
                            }
                          />
                        )}
                      />
                      {loadingiBranchAddress && (
                        <CircularProgress
                          className={classes.circularProgress}
                          disableShrink={true}
                          size={18}
                          thickness={6}
                        />
                      )}
                    </div>
                  );
                }}
              </Field>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Field
                name="enderecoFilial.deBairro"
                label="Bairro*"
                variant="filled"
                margin="dense"
                disabled={
                  !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
                }
                fullWidth
                error={!!errors.enderecoFilial?.deBairro}
                helperText={errors.enderecoFilial?.deBairro ? errors.enderecoFilial.deBairro : ''}
                value={values.enderecoFilial?.deBairro ? values.enderecoFilial.deBairro : ''}
                as={TextField}
                inputProps={{
                  maxLength: 50,
                  form: {
                    autocomplete: 'off',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="enderecoFilial.deEndereco"
                label="Endereço*"
                variant="filled"
                margin="dense"
                disabled={
                  !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
                }
                fullWidth
                error={!!errors.enderecoFilial?.deEndereco}
                helperText={
                  errors.enderecoFilial?.deEndereco ? errors.enderecoFilial.deEndereco : ''
                }
                value={values.enderecoFilial?.deEndereco ? values.enderecoFilial.deEndereco : ''}
                as={TextField}
                inputProps={{
                  maxLength: 50,
                  form: {
                    autocomplete: 'off',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Field
                name="enderecoFilial.deNumeroEndereco"
                label="Número"
                variant="filled"
                margin="dense"
                disabled={
                  !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
                }
                fullWidth
                error={!!errors.enderecoFilial?.deNumeroEndereco}
                helperText={
                  errors.enderecoFilial?.deNumeroEndereco
                    ? errors.enderecoFilial.deNumeroEndereco
                    : ''
                }
                value={
                  values.enderecoFilial?.deNumeroEndereco
                    ? values.enderecoFilial.deNumeroEndereco
                    : ''
                }
                as={TextField}
                inputProps={{
                  maxLength: 10,
                  form: {
                    autocomplete: 'off',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Field
                name="enderecoFilial.deComplemento"
                label="Complemento"
                variant="filled"
                margin="dense"
                disabled={
                  !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
                }
                fullWidth
                value={
                  values.enderecoFilial?.deComplemento ? values.enderecoFilial.deComplemento : ''
                }
                as={TextField}
                inputProps={{
                  maxLength: 50,
                  form: {
                    autocomplete: 'off',
                  },
                }}
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}

export default Address;
